export const SIZE_TABLET = 767
export const SIZE_DESKTOP = 992
export const SIZE_DESKTOP_WIDE = 1600

export const MEDIA_QUERY_TABLET = `@media only screen and (min-width: ${SIZE_TABLET}px)`
export const MEDIA_QUERY_DESKTOP = `@media only screen and (min-width: ${SIZE_DESKTOP}px)`
export const MEDIA_QUERY_DESKTOP_WIDE = `@media only screen and (min-width: ${SIZE_DESKTOP_WIDE}px)`
